(() => {
  const layoutStyleId = 'eg-redo-cart-checkout-layout';
  const checkoutWithoutCoverageLabel = 'No thanks - checkout without free returns';
  const observedShadowRoots = new WeakSet();
  const pendingHosts = window.__egRedoCheckoutBootstrap?.hosts || new Set();

  if (!window.__egRedoCheckoutBootstrap) {
    const originalAttachShadow = Element.prototype.attachShadow;

    Element.prototype.attachShadow = function attachShadow(init) {
      if (this.localName !== 'redo-shopify-toggle') {
        return originalAttachShadow.call(this, init);
      }

      const shadowRoot = originalAttachShadow.call(this, { ...init, mode: 'open' });
      pendingHosts.add(this);
      queueMicrotask(() => window.__egApplyRedoCheckoutLayout?.(this));
      return shadowRoot;
    };

    window.__egRedoCheckoutBootstrap = { hosts: pendingHosts };
  }

  const applyCartCheckoutLayout = (host) => {
    pendingHosts.delete(host);
    if (!host.closest('.drawer__footer')) return;

    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) return;

    const infoCard = shadowRoot.querySelector('[data-target="info-card-container"]');
    const coverageButton = shadowRoot.querySelector('[data-target="coverage-button"]');
    host.toggleAttribute('data-eg-redo-ready', Boolean(infoCard && coverageButton));

    // Redo's saved styles reference an old theme/domain asset. An inline
    // override also wins over the widget's more specific mobile button rules.
    if (coverageButton) {
      const mask = 'var(--eg-cart-checkout-mask, none)';
      coverageButton.style.setProperty('-webkit-mask-image', mask, 'important');
      coverageButton.style.setProperty('mask-image', mask, 'important');
    }

    if (!observedShadowRoots.has(shadowRoot)) {
      observedShadowRoots.add(shadowRoot);
      let pendingFrame = 0;
      const shadowObserver = new MutationObserver(() => {
        if (pendingFrame) return;
        pendingFrame = requestAnimationFrame(() => {
          pendingFrame = 0;
          if (host.isConnected) applyCartCheckoutLayout(host);
        });
      });
      shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
    }

    if (!shadowRoot.getElementById(layoutStyleId)) {
      const style = document.createElement('style');
      style.id = layoutStyleId;
      style.textContent = `
        :host(:not([data-eg-redo-ready])) {
          display: none !important;
        }

        @media (max-width: 989px) {
          :host([data-eg-redo-ready]) {
            display: grid !important;
            grid-template-columns: minmax(0, 0.9fr) minmax(164px, 1.35fr) !important;
            column-gap: 12px !important;
            row-gap: 0 !important;
            align-items: center !important;
          }

          [data-target='info-card-container'] {
            grid-column: 1 !important;
            grid-row: 1 !important;
            min-width: 0 !important;
            margin: 0 !important;
          }

          [data-target='toggle-label'] {
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
            font-size: 13px !important;
            white-space: nowrap !important;
          }

          [data-target='toggle-info'] {
            display: inline-flex !important;
            position: static !important;
          }

          [data-target='toggle-info-button'] {
            position: static !important;
            flex: 0 0 14px !important;
            width: 14px !important;
            height: 14px !important;
            margin: 0 !important;
          }

          [data-target='price'],
          [data-target='info-card-container'] > div:has(> [data-target='price']) {
            display: none !important;
          }

          [data-target='checkout-buttons-container'] {
            display: contents !important;
          }

          [data-target='coverage-button'] {
            grid-column: 2 !important;
            grid-row: 1 !important;
            align-self: center !important;
            width: 100% !important;
            min-height: 48px !important;
            margin: 0 !important;
          }

          [data-target='non-coverage-button'] {
            grid-column: 1 / -1 !important;
            grid-row: 2 !important;
            justify-self: center !important;
            width: auto !important;
            margin: 0 !important;
            padding: 3px 8px !important;
          }
        }

        @media (max-width: 340px) {
          :host([data-eg-redo-ready]) {
            grid-template-columns: minmax(0, 1fr) 145px !important;
            column-gap: 8px !important;
          }

          [data-target='info-card-container'] {
            gap: 6px !important;
          }

          [data-target='info-card-container'] > div:has(> [data-target='info-card-image']) {
            flex: 0 0 28px !important;
            width: 28px !important;
          }

          [data-target='info-card-image'] {
            width: 28px !important;
            height: 36px !important;
            object-fit: contain !important;
          }

          [data-target='text-and-buttons-container'] {
            min-width: 0 !important;
          }

          [data-target='toggle-label'] {
            font-size: 10.5px !important;
            white-space: nowrap !important;
          }

          [data-target='toggle-info-button'] {
            width: 14px !important;
            height: 14px !important;
          }

          [data-target='toggle-subtext'] {
            display: block !important;
            font-size: 10px !important;
            line-height: 1.2 !important;
          }

          :host([data-eg-redo-ready]) [data-target='coverage-button'] {
            font-size: 12px !important;
            padding-right: 8px !important;
            padding-left: 8px !important;
          }

          :host([data-eg-redo-ready]) [data-target='coverage-button'] [data-target='headline-text-container'] > p[data-arbiter='Text'] {
            font-size: 12px !important;
            white-space: nowrap !important;
          }

        }

        @media (min-width: 990px) {
          :host([data-eg-redo-ready]) {
            display: grid !important;
            grid-template-columns: minmax(0, 1.2fr) minmax(300px, 1fr) !important;
            column-gap: 12px !important;
            row-gap: 2px !important;
            align-items: center !important;
          }

          [data-target='info-card-container'] {
            grid-column: 1 !important;
            grid-row: 1 !important;
            min-width: 0 !important;
            margin: 0 !important;
          }

          [data-target='price'],
          [data-target='info-card-container'] > div:has(> [data-target='price']) {
            display: none !important;
          }

          [data-target='checkout-buttons-container'] {
            display: contents !important;
          }

          [data-target='coverage-button'] {
            grid-column: 2 !important;
            grid-row: 1 !important;
            align-self: center !important;
            width: 100% !important;
            margin: 0 !important;
          }

          [data-target='non-coverage-button'] {
            grid-column: 1 / -1 !important;
            grid-row: 2 !important;
            justify-self: center !important;
            width: auto !important;
            margin: 0 !important;
            padding: 3px 10px !important;
          }
        }
      `;
      shadowRoot.appendChild(style);
    }

    const noThanksButton = shadowRoot.querySelector('[data-target="non-coverage-button"]');
    const noThanksText = noThanksButton?.querySelector('p');
    const coveragePrice = shadowRoot.querySelector('[data-target="price"]');

    if (coveragePrice) {
      coveragePrice.hidden = true;
      coveragePrice.setAttribute('aria-hidden', 'true');
      coveragePrice.parentElement?.style.setProperty('display', 'none', 'important');
    }

    if (noThanksButton && noThanksButton.getAttribute('aria-label') !== checkoutWithoutCoverageLabel) {
      noThanksButton.setAttribute('aria-label', checkoutWithoutCoverageLabel);
    }

    if (noThanksText && noThanksText.textContent !== checkoutWithoutCoverageLabel) {
      noThanksText.textContent = checkoutWithoutCoverageLabel;
    }
  };

  window.__egApplyRedoCheckoutLayout = applyCartCheckoutLayout;
  pendingHosts.forEach((host) => queueMicrotask(() => applyCartCheckoutLayout(host)));

  const scanForCartCheckout = (root = document) => {
    if (root.matches?.('redo-shopify-toggle')) applyCartCheckoutLayout(root);
    root.querySelectorAll?.('redo-shopify-toggle').forEach(applyCartCheckoutLayout);
  };

  const start = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    scanForCartCheckout(drawer);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) scanForCartCheckout(node);
        });
      });
    });

    observer.observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
